import React from 'react';
import * as styles from './css/grid.module.scss';

const _Grid = props => <div className={styles.main}>{props.children}</div>;

export default _Grid;
